import { features } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', iconBg: 'bg-accent-100' },
};

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              为什么选择<span className="text-primary-600">久久在线</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              六大核心优势，为您提供卓越的在线服务体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature) => {
              const c = colorMap[feature.color] || colorMap.primary;
              return (
                <div
                  key={feature.title}
                  className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.iconBg} ${c.text} mb-5 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}